<template>
	<div style="padding-bottom: 50px;">
		<!-- <div class="course mb-50 mt-50">
			<div class="flex-space title">
				<h3 class="fsm6">直播预告</h3>
				<router-link tag="span" :to="{path:'/course?type='+3+'&name=zbyg&code='+propCode}" class="flex-alitem cursor">
					更多<img class="ml-5" src="../../../../static/index/arr-r.png" width="16px" height="16px" alt="">
				</router-link>
			</div>
			<LiveCourse :parentsData="dataProp" :name="'zbyg'"></LiveCourse>
		</div> -->
		<div class="course mt-50">
			<div class="flex-space title">
				<h3 class="fsm6">免费好课</h3>
				<router-link tag="span" :to="{path:'/course?type='+7+'&name=mfhk&code='+propCode}" class="flex-alitem cursor">
					更多<img class="ml-5" src="../../../../static/index/arr-r.png" width="16px" height="16px" alt="">
				</router-link>
			</div>
			<GroupCourse :Data="dataFree" :name="'mfhk'"></GroupCourse>
		</div>
		<!-- <router-link tag="div" :to="{path:'/'}">
			<img src="../../../../static/del/pro.jpg" alt="">
		</router-link> -->
		<div class="course mt-20">
			<div class="flex-space title">
				<h3 class="fsm6">精品推荐</h3>
				<router-link tag="span" :to="{path:'/course?type='+7+'&name=jptj&code='+propCode}" class="flex-alitem cursor">
					更多<img class="ml-5" src="../../../../static/index/arr-r.png" width="16px" height="16px" alt="">
				</router-link>
			</div>
			<GroupCourse :Data="dataJing" :name="'jptj'"></GroupCourse>
		</div>
		<div class="course mt-20 mb-50">
			<div class="flex-space title">
				<h3 class="fsm6">拼团报课</h3>
				<router-link tag="span" :to="{path:'/course?type='+1+'&name=ptbk'+'&code='+propCode}" class="flex-alitem cursor">
					更多<img class="ml-5" src="../../../../static/index/arr-r.png" width="16px" height="16px" alt="">
				</router-link>
			</div>
			<div class="group" v-if="dataGroup.length > 0">
				<el-scrollbar>
					<PtCourse :ptProp="dataGroup"></PtCourse>
				</el-scrollbar>
			</div>
			<div v-else>
				<noData></noData>
			</div>
		</div>
		<div class="course mt-20">
			<div class="flex-space title">
				<h3 class="fsm6">热门推荐</h3>
				<router-link tag="span" :to="{path:'/course?type='+7+'&name=rmtj&code='+propCode}" class="flex-alitem cursor">
					更多<img class="ml-5" src="../../../../static/index/arr-r.png" width="16px" height="16px" alt="">
				</router-link>
			</div>
			<GroupCourse :Data="dataHot" :name="'rmtj'"></GroupCourse>
		</div>
	</div>
</template>

<script>
	import LiveCourse from '@/components/Course/live.vue'
	import PtCourse from '@/components/Course/ptClass.vue'
	import GroupCourse from '@/components/Course/group.vue'
	import noData from '@/components/noData/index.vue'
	export default{
		components: {
			LiveCourse,
			GroupCourse,
			PtCourse,
			noData
		},
		props: {
			propTab: {
				type: Number,
				default: 1
			},
			dataProp:{
				type:Array,
				default:()=>{ return [] }
			},
			dataJing:{
				type:Object,
				default:()=>{ return {} }
			},
			dataClass:{
				type:Object,
				default:()=>{ return {} }
			},
			dataFree:{
				type:Object,
				default:()=>{ return {} }
			},
			dataHot:{
				type:Object,
				default:()=>{ return {} }
			},
			dataGroup:{
				type:Array,
				default:()=>{ return [] }
			},
			propCode:{
				type:String,
				default:''
			}
		},
		data() {
			return {

			}
		}
	}
</script>

<style lang="less" scoped>
	.course{
		.title{
			margin-bottom: 25px;
		}
	}
	.group{
		.groupItem{
			width: 450px;
			background-color: #fff;
			padding: 25px 20px;
			display: inline-block;
			margin-right: 20px;
			box-shadow: 0 0 5px 1px #e5e5e5;
			&:hover{
				box-shadow: 0 0 5px 1px #cdcdcd;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/view/index/components/class1.vue